import styled from 'styled-components'
import theme from 'stories/utils/theme'

export const Container = styled.footer`
    width: 100%;
    min-height: 450px;
    background: ${theme.colors.darkThemeBackgroundGradient};
    display: grid;
    grid-gap: 15px;
    z-index: ${theme.zIndex.navBar};
    bottom: 0px;
    left: 0;
    right: 0;
`

export const Grid = styled.div`
    padding: 48px;
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr;
    border-bottom: 1px solid ${theme.colors.backgroundTransparent};
    position: relative;

    @media (max-width: 1150px) {
        grid-template-columns: 1fr 1fr;
        gap: 20px;
    }

    @media (max-width: 750px) {
        display: block;
        padding: 36px;

        & > div:first-child {
            margin-bottom: 40px;
        }

        & > div:nth-child(2),
        & > div:nth-child(3) {
            display: inline-block;
            width: 50%;
            vertical-align: top;
            margin-bottom: 40px;
        }

        & > div:nth-child(4) {
            display: block;
            width: 100%;
        }
    }
`

export const LinkColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: start;
    padding: 0px;
    & ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
    }

    & li {
        margin: 5px 0;
        font-family: var(--font-inter);
        font-weight: 400 !important;
    }
    p {
        margin: 0;
        font-family: var(--font-inter);
    }

    & a,
    & .fake-link {
        cursor: pointer;
        color: ${theme.colors.grayScaleSecondary};
        font-size: 14px;
        line-height: 21px;
        font-weight: 400 !important;
        font-family: var(--font-inter);
        :hover {
            color: ${theme.colors.lightCaption};
        }
    }

    & strong {
        color: ${theme.colors.white};
        font-family: var(--font-inter);
    }
    @media (max-width: 750px) {
        padding: 0;
        & a,
        & .fake-link {
            font-size: 16px;
            font-weight: 500;
            line-height: 1.5;
            margin: 12px 0;
        }
        & strong {
            font-size: 20px;
            font-weight: 600;
            line-height: 30px;
            letter-spacing: 0em;
            margin-bottom: 4px;
        }
        .logo-row {
            display: flex;
            align-items: center;
            gap: 10px;

            img {
                width: 24px;
                height: 34px;
            }

            p {
                font-size: 44px;

                @media (max-width: 480px) {
                    font-size: 40px;
                    font-weight: 600;
                }
            }
        }
    }
`

export const LegalArticlesRow = styled.div`
    display: flex;
    row-gap: 10px;
    column-gap: 30px;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    padding: 10px;
    @media (max-width: 750px) {
        row-gap: 20px;
        padding: 20px;
        a,
        span {
            font-family: var(--font-inter);
            font-weight: 400;
            font-size: 15px !important;
            padding: 0;
            margin: 0 !important;
        }
    }
`

export const ButtonWrapper = styled.div`
    position: absolute;
    bottom: 6px;
    left: 0;
    background-color: ${theme.colors.accentBlue};
`

export const SocialIcons = styled.div`
    display: flex;
    gap: 10px;
    a {
        padding: 10px;
        background-color: ${theme.colors.backgroundTransparent};
        border-radius: ${theme.borderRadius.content};
        height: fit-content;
        width: fit-content;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    & svg {
        width: 25px;
        height: 25px;
    }
`
